// extracted by mini-css-extract-plugin
module.exports = {"container":"StatCards_container__AhCIk","item":"StatCards_item__nUjYb","description":"StatCards_description__mKejT"};